// extracted by mini-css-extract-plugin
export default {"AdSlotOffsite":"bhi_a bih_bi"};